import { DashboardModule, Form } from '@domain-group/suit-theme'

import PortalDataInput from '../PortalDataInput'

const ListingDetails = () => (
  <DashboardModule boxProps={{ flexDirection: 'column' }} title="Listing Details">
    <Form padding="large">
      <PortalDataInput fieldKey="authority" />

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="commercialAuthority" />

        <PortalDataInput marginTop="large" fieldKey="auctionDate" />

        <PortalDataInput marginTop="large" fieldKey="setSaleDate" />

        <PortalDataInput marginTop="large" fieldKey="auctionTime" />

        <PortalDataInput marginTop="large" fieldKey="setSaleTime" />
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="priceView" />

        <PortalDataInput marginTop="large" fieldKey="price" />
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="rentalPeriod" />

        <PortalDataInput marginTop="large" fieldKey="bond" />

        <PortalDataInput marginTop="large" fieldKey="hidePrice" />
      </Form.Row>
    </Form>
  </DashboardModule>
)

export default ListingDetails
